import type { AnalyticsEventName } from './analytics-types.js';
import type { EVENT_PROP_ALLOWLIST } from './analytics-schema.js';

// These lifecycle events can run during startup, restoration, or background work.
const PASSIVE_EVENTS = new Set<string>([
  'button_rage_click_detected',
  'suspected_dead_click',
  'locate_search_recovered',
  'locate_search_task_continued',
  'competitor_app_opened',
  'share_target_consumed',
  'library_opened',
  'recent_map_resumed',
  'map_created',
  'map_updated',
  'data_layer_added',
  'satellite_tile_session',
  'autocomplete_request_finished',
  'reverse_geocode_outcome',
  'premium_trial_started',
  'premium_trial_ended',
  'globe_session_ended',
  'service_area_handoff_consumed',
  'service_area_boundary_ready',
  'rp_route_succeeded',
  'map_route_preview_ready',
  'map_route_calculation_failed',
  'route_planner_route_fetched',
  'pro_checkout_redirected',
  'pro_checkout_embedded_opened',
  'pro_checkout_completed',
  'pro_checkout_pending',
  'pro_checkout_cancelled',
  'pro_checkout_recovered',
  'checkout_export_preparing',
  'checkout_export_completed',
  'paid_export_fulfilled',
  'export_download_started',
  'export_pending_15s',
  'export_png_succeeded',
  'export_pdf_succeeded',
  'export_geojson_succeeded',
  'export_kml_succeeded',
  'image_import_succeeded',
  'embed_map_page_scroll_depth',
  'save_draft_state_lost',
  'my_maps_redirected_to_signin',
  'ai_map_credits_exhausted',
  'ai_map_limit_reached',
] satisfies Array<AnalyticsEventName<typeof EVENT_PROP_ALLOWLIST>>);

const PASSIVE_EVENT_PATTERNS = [
  /(?:^|_)session_mode$/,
  /(?:^|_)(?:engaged_\d+s|no_action_\d+s|no_interaction_\d+s|app_ready_slow_\d+s|abandoned_\d+s)$/,
  /_(?:viewed|shown|exposed|loaded|performance|prompted|required|expired|ignored|invalid)$/,
  /(?:^|_)(?:failed|error|denied)(?:_|$)/,
  /(?:^|_)locate_(?:path|permission_state)_/,
  /^thumbnail_/,
  /^my_maps_chunk_recovery_/,
];

export function isPlausibleEventInteractive(event: string, props: Readonly<Record<string, string>> = {}): boolean {
  if (event === 'my_maps_action' && (props.action === 'load' || props.action === 'collaborators_load')) return false;
  return !PASSIVE_EVENTS.has(event) && !PASSIVE_EVENT_PATTERNS.some(pattern => pattern.test(event));
}
